<template>
  <div
     class="dropbox-container"
     :style="{top: y === null ? null : y + 'px', left: x === null ? null : x + 'px', width: w === null ? null : w + 'px'}" >
    <div
       ref="header"
       class="header"
       @mousedown="dragstart"
       :style="{'border-radius': collapsed ? '4px 4px 4px 4px' : '4px 4px 0px 0px'}" >
      <div class="title" >
        <slot name="header" >{{ title }}</slot>
      </div>
      <div class="actions" >
        <template v-if="collapsable" >
          <i
             v-if="!collapsed"
             class="el-icon-arrow-up"
             @mousedown.stop=""
             @click.stop="collapsed = true" >
          </i>
          <i
             v-else
             class="el-icon-arrow-down"
             @mousedown.stop=""
             @click.stop="collapsed = false" >
          </i>
        </template>
        <i
           v-if="discardable"
           class="el-icon-close"
           @mousedown.stop=""
           @click.stop="$emit('discard')" >
        </i>
      </div>
    </div>
    <div class="body" v-if="!collapsed" :style="{'max-height': maxHeight + 'px'}" >
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.dropbox-container {
    position: fixed;
    box-shadow: 0px 0px 5px 3px #656565;
    border-radius: 4px;
    z-index: 2000;
    display: flex;
    flex-direction: column;
}
.dropbox-container .header {
    cursor: move;
    background: linear-gradient(#075269, #0C4769);
    padding: 5px;
    color: #FFF;
    display: flex;
}
.header .title {
    flex: 1;
}
.header .actions i {
    cursor: pointer;
    margin-left: 3px;
}
.dropbox-container .body {
    padding: 5px;
    background-color: #eaeaf4;
    overflow-y: auto;
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    top: {
      type: Number,
      required: false
    },
    right: {
      type: Number,
      required: false
    },
    left: {
      type: Number,
      required: false
    },
    bottom: {
      type: Number,
      required: false
    },
    width: {
      type: Number,
      required: false
    },
    collapse: {
      type: Boolean,
      default: false
    },
    discardable: {
      type: Boolean,
      default: false
    },
    collapsable: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: Number,
      default: Math.round(
        (isNaN(window.innerHeight) ? window.clientHeight : window.innerHeight) * 0.8
      )
    }
  },
  mounted () {
    if (this.width) {
      this.w = this.width
    } else {
      this.w = this.$el.getBoundingClientRect().width
    }

    this.$nextTick(() => {
      const parentRect = this.$el.parentElement.getBoundingClientRect()
      const rect = this.$el.getBoundingClientRect()
      if (this.top) {
        this.y = parentRect.y + this.top
      } else if (this.bottom) {
        this.y = parentRect.bottom - this.bottom - rect.height
      } else {
        this.y = parentRect.y
      }

      if (this.left) {
        this.x = parentRect.x + this.left
      } else if (this.right) {
        this.x = parentRect.right - this.right - rect.width
      } else {
        this.x = parentRect.x
      }
    })
  },
  data () {
    return {
      x: null,
      y: null,
      w: null,
      startX: null,
      startY: null,
      collapsed: this.collapse
    }
  },
  computed: {
    containerPosition () {
      return {
        top: this.y,
        left: this.x
      }
    }
  },
  methods: {
    dragstart (evt) {
      this.startX = evt.clientX
      this.startY = evt.clientY
      document.addEventListener('mouseup', this.dragEnd)
      document.addEventListener('mousemove', this.drag)
    },
    drag (evt) {
      this.x += evt.clientX - this.startX
      this.y += evt.clientY - this.startY
      this.startX = evt.clientX
      this.startY = evt.clientY
    },
    dragEnd () {
      const height = window.innerHeight || document.documentElement.clientHeight ||
            document.body.clientHeight
      const width = window.innerWidth || document.documentElement.clientWidth ||
            document.body.clientWidth
      const bbox = this.$refs.header.getBoundingClientRect()
      this.y += Math.min(height - bbox.height - bbox.y, 0)
      this.y += -Math.min(bbox.y, 0)
      this.x += Math.min(width - bbox.width - bbox.x, 0)
      this.x += -Math.min(bbox.x, 0)
      document.removeEventListener('mouseup', this.dragEnd)
      document.removeEventListener('mousemove', this.drag)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/data/components/DraggableBox.vue